<!--
 * @Description 回款选择销售单
-->
<template>
  <div class="wk-checkbox">
      <crm-select
        class="sale-select"
        v-model="salesIds"
        filterable
        :disabled="disabled"
        :clearable="clearable"
        :placeholder="placeholder"
        style="width: 100%;"
        multiple
        @change="valueSalesChange">
        <el-option
          v-for="(item, index) in options"
          :key="index"
          :label="item.title"
          :value="item.id" />
      </crm-select>
     <div v-if="Array.isArray(tableData) && tableData.length" class="sales-table">
      <el-table
        :data="tableData"
        :border="true"
        :header-cell-style="{background: '#f6f7f9',color: '#666'}"
        class="table-list"
        style="width: 100%;">
        <el-table-column
          :resizable="false"
          width="250px"
          prop="number"
          label="销售单">
          <template slot-scope="scope">
            <div class="title" @click="jumpSaleDetail(scope.row.id)">{{ scope.row.title }}</div>
          </template>
        </el-table-column>
        <el-table-column
          :resizable="false"
          label="应收"
          width="90px"
          prop="saleFee">
          <template slot-scope="{ row, column }">
            <div>{{ row.price && row.price.saleFee? beautifyThePrice(row.price.saleFee, ',', 2, '¥') : '-'}} 
            </div>
					</template>
        </el-table-column>
          
        <el-table-column
          :resizable="false"
          label="应收押金"
          width="90px"
          prop="depositFee">
          <template slot-scope="{ row, column }">
            <div>{{ row.price && row.price.depositFee? beautifyThePrice(row.price.depositFee, ',', 2, '¥') : '-'}} 
            </div>
					</template>
        </el-table-column>
        <el-table-column
          :resizable="false"
          width="340px"
          prop="detail"
          label="回款明细">
          <template slot-scope="scope">
            <div class="detail">
              <div v-for="(item,index) in scope.row.receivedAmount" 
              :key="`${scope.$index}-${index}`" 
              class="item">
                <crm-select
                  v-model="item.type"
                  filterable
                  :disabled="disabled"
                  @change="valueChange"
                  :clearable="clearable">
                  <el-option
                    v-for="item in typeOptions"
                    :key="item.value"
                    :label="item.label"
                    :disabled="scope.row.receivedAmount.some(itm=>itm.type === item.value)"
                    :value="item.value" />
                </crm-select>
                <Input
                  v-model="item.value"
                  :disabled="disabled"
                  :controls="false"
                  placeholder="请输入金额"
                  custom-type="float" :float-length="2"
                  max="999999999"
                  :min="0"
                  @change="valueChange"/>
                <div v-if="scope.row.receivedAmount.length > 1 && !disabled" class="btn" @click="remove(scope.$index,index)">删除</div>
                <div v-if="index === (scope.row.receivedAmount.length - 1)  && !disabled" class="btn" @click="add(scope.$index,index)">添加</div>
               
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
     </div>
  </div>
</template>

<script>
import { isObject, isEmpty, isArray } from '@/utils/types'
import { valueEquals } from 'element-ui/lib/utils/util'
import Emitter from 'element-ui/lib/mixins/emitter'
import { beautifyThePrice } from '@lhb/func';
import Input from 'src/common/components/Input/index.vue';
import { crmContractQuerySalesAPI } from '@/api/crm/contract'
import { title } from 'process';

export default {
  // 销售单 多选
  name: 'WkCheckbox',

  components: {
    Input
  },

  mixins: [Emitter],

  props: {
    // eslint-disable-next-line vue/require-prop-types
    value: {},
    disabled: Boolean,
    clearable: Boolean,
    placeholder: String,
    relation: {
      type: Object,
      default: ()=>({})
    }
  },

  data() {
    return {
      beautifyThePrice,
      salesIds: [],
      typeOptions: [
        {
          value: 1,
          label: '场地费'
        },
        {
          value: 2,
          label: '第三方成本'
        },
        {
          value: 3,
          label: '他项'
        },
        {
          value: 4,
          label: '押金'
        }
      ],
      options: [],
      tableData: []
    }
  },

  computed: {
   
  },

  watch: {
    value: {
      handler(newVal, oldVal) {
        this.validValue()
      },
      immediate: true
    },
    relation: {
      handler(val) {
        if (val.num || val.contractNum) {
          this.getSaleOptions()
        } else {
          this.options = []
        }
      },
      deep: true,
      immediate: true
    }
  },

  beforeDestroy() {},

  methods: {
    getSaleOptions() {
      this.loading = true
      const params = {contractKeyword: this.relation.num || this.relation.contractNum, page: 1, size: 999};
      crmContractQuerySalesAPI(params).then((res) => {
        this.loading = false;
        const { objectList = [] } = res;
        this.options = objectList;
      }).catch(() => {
          this.loading = false;
        })
    },
    jumpSaleDetail(id) {
      window.open(`/lhb-micro-pms/sales/detail?id=${id}`, '_blank')
    },

    remove($index,index) {
      this.tableData[$index].receivedAmount.splice(index,1)
    },

    add($index,index) {
      this.tableData[$index].receivedAmount.push({
        type:'',
        value:''
      })
    },
    /**
     * 验证值
     */
    validValue() {
      if (isEmpty(this.value)) {
        this.tableData = [];
        this.salesIds = [];
      } else {
        this.salesIds = this.value.map(item=> +item.saleOrderId);
        this.tableData = this.value.map(item=> {
          return {
            id: +item.saleOrderId,
            number: item.number,
            title: item.title,
            receivedAmount: item.receivedAmount,
            price: {
              depositFee: item.deposit,
              saleFee: item.placeFee
            }
          }
        });
      }
    },

    /**
     * 选项值
     */
    getValue(item) {
      return !this.isEmptyValue(item.value) ? item.value : item
    },

    /**
     * 判断是空值
     */
    isEmptyValue(value) {
      return value === null || value == undefined
    },

    valueSalesChange() {
      const tableData = this.options.filter(item=>{
        return this.salesIds.includes(item.id)
      }).map(item =>{
        if(!this.tableData.some(itm=>itm.id === item.id)) {
          this.$set(item,'receivedAmount',[
            {
              type:'',
              value:''
            }
          ])
        }
        return item;
      })

      this.tableData = tableData;
      this.valueChange();
      
    },

    /**
     * 值更新
     */
    valueChange() {

      this.$emit('value-change', {
        value: this.tableData.map(item => {
          return {
            number: item.number,
            title: item.title,
            saleOrderId: item.id,
            receivedAmount: item.receivedAmount,
            deposit: item.price.depositFee,
            placeFee: item.price.saleFee,
          }
        })
      })
    },

    /**
     * 失去焦点
     */
    inputBlur() {
      this.valueChange()
    }
  }
}
</script>

<style lang="scss" scoped>
.wk-checkbox {
  .title {
    color: #2441B3 !important;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  /deep/.el-select {
    width: 48.5% !important;
    .el-select__tags-text {
      display: inline-block;
      max-width: 200px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .el-tag__close.el-icon-close {
      top: -7px;
    }
  }
  

  .el-checkbox-group {
    line-height: 1.5;
  }
  .sales-table {
    margin-top: 12px;
  }
  .detail {
    .el-input {
      margin-left: 6px;
      width: 120px;
    }
    .el-select {
      width: 118px !important;
    }
    .item {
      margin-top: 5px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .btn {
        margin-left: 12px;
        color: #006AFF !important;
        cursor: pointer;
      } 
    }
  }
}
</style>
